import { useState } from 'react';

const useModal = (): [boolean, () => void, () => void] => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const handleShow = () => setShowModal(true);
  const handleHide = () => setShowModal(false);

  return [showModal, handleShow, handleHide];
};

export default useModal;
